exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status[data-v-00c5ba80]{text-transform:capitalize\n}\n.tours-filter[data-v-00c5ba80]{margin-right:10px\n}\n.tours-filter input[data-v-00c5ba80]{margin:0;padding:10px\n}\n.model[data-v-00c5ba80]:not(:last-child):after{content:\", \"\n}\n.remove-item[data-v-00c5ba80]{background:transparent;border:0;box-shadow:none;color:#586678;cursor:pointer;font-weight:400\n}", ""]);

// exports
